import {
  calculateBomTotals,
  sortBomLineItems,
  valid_buy_options,
} from '../../utils/helpers';

export const sortBomLineItemsByStatus = (state) => {
  state.bom_line_items = sortBomLineItems(
    state.bom_line_items,
    state.selected_board_qty,
  );
};

export const updateBomTotals = (state) => {
  state.totals = calculateBomTotals(state.bom_line_items, state.board_qtys);
};

export const updateSelectedBoardQty = (state, selected_board_qty) => {
  state.selected_board_qty = selected_board_qty;
  state.bom_line_items.forEach((bli, index) => {
    const { error_message, user_action } = bli;
    if (
      valid_buy_options.includes(user_action) &&
      error_message[selected_board_qty] &&
      error_message[selected_board_qty] !== ''
    ) {
      state.bom_line_items[index].user_action = '';
    }
  });
};
